<div class="orange" *ngIf="topheaderbanner">
  <div [class]="containerCss" [innerHtml]="topheaderbannerHTMl"></div>
</div>
<nav
  class="navbar navbar-expand-lg navbar-dark   mb-3 head-top-home {{
    navbarcss
  }} fixed-top"
>
  <div [class]="containerCss">
    <div class="row">
      <div class="col-md-6">
        <a class="navbar-brand">
          <img class="header-logo-home" [src]="imageURL" alt="" />
          <div
            class="logotxt"
            *ngIf="logowithtxt"
            [innerHtml]="logowithtxtHTML"
          ></div>
        </a>
      </div>

      <div class="col-md-6 text-right lgout hed-btn">
        <div class="col-md-12 text-right wl-btn">
          <div class="dropdown hed-btn">
            <button
              class="btn btn-outline-dark btn-sm mt-4 p-2 cursor-pointe"
              class="dropbtn py-2 px-3"
              (click)="demoLink()"
            >
              <i class="fa fa-pencil-square-o mr-2" aria-hidden="true"></i>Book
              Demo
            </button>
            <button
              class="btn btn-outline-dark btn-sm mt-4 p-2 cursor-pointe"
              class="dropbtn py-2"
              (click)="login()"
            >
              <i class="fa fa-sign-in mr-2"></i>Sign in
            </button>
            <!-- <button >Dropdown</button> -->
            <div
              class="dropdown-content bg-white Larger shadow border"
              *ngIf="isLoginModelShow"
            >
              <div class="p-3 rounded">
                <div class="row">
                  <div class="col-md-12 right-col">
                    <div class="login-sec row">
                      <div class="col-sm-12"></div>
                      <div class="col-sm-12">
                        <form [formGroup]="formlogin" (ngSubmit)="onLogin()">
                          <div class="form-group text-left mb-0">
                            <h1
                              class="header-login mb-0 pb-0"
                              style="color: antiquewhite"
                            >
                              Login
                            </h1>
                          </div>
                          <div class="form-group mb-0">
                            <label for="exampleFormControlInput1"></label>
                            <input
                              type="email"
                              name="userName"
                              formControlName="user"
                              class="form-control"
                              id="userName"
                              placeholder="Username"
                              ngModel
                              required
                            />
                          </div>
                          <div class="form-group mb-0 relative">
                            <label for="exampleFormControlInput1"></label>
                            <div class="relative">
                              <div class="absolute pass-HideShow">
                                <svg
                                  (click)="hide = !hide"
                                  *ngIf="hide"
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="h-5 w-5 text-gray-500 cursor-pointer"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                  stroke-width="2"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                                  />
                                </svg>
                                <svg
                                  (click)="hide = !hide"
                                  *ngIf="!hide"
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="h-5 w-5 text-gray-500 cursor-pointer"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                  stroke-width="2"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                  />
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                  />
                                </svg>
                              </div>
                              <input
                                name="userPassword"
                                formControlName="pass"
                                class="form-control"
                                [type]="hide ? 'password' : 'text'"
                                id="password"
                                maxlength="50"
                                placeholder="Password"
                                ngModel
                                required
                              />
                            </div>
                          </div>
                          <div class="form-group row mt-4 mb-0">
                            <div class="col-md-12 text-center">
                              <button
                                class="btn btn-outline-dark btn-sm mt-3 p-2"
                                [disabled]="!formlogin.valid || IsLoadData"
                                class="dropbtn"
                              >
                                <i class="fa fa-sign-in mr-1"></i> Sign in
                              </button>
                            </div>

                            <div class="col-md-12 text-center mb-2">
                              <tui-root>
                                <div *ngIf="IsLoadData">
                                  <tui-loader [inheritColor]="true">
                                  </tui-loader>
                                </div>
                              </tui-root>
                            </div>
                            <ul class="d-flex align-items-center m-0 p-0 mt-2">
                              <li class="dropup">
                                <div
                                  class="col-md-12 ml-1 text-center pri-btn d-flex justify-content-between align-items-center"
                                >
                                  <!-- Create Account -->
                                  <a id="create-hover" (click)="signupshow()"
                                    >Create Account
                                  </a>
                                  <div class="" style="margin-left: 43px">
                                    <!-- Create Account -->
                                    <a
                                      id="create-hover"
                                      style="text-decoration: none"
                                      [routerLink]="['/home/ResetPassword']"
                                      target="_blank"
                                      >Forgot Password?
                                    </a>
                                  </div>
                                </div>

                                <div
                                  class="dropup-content cost-list"
                                  *ngIf="signupshowpopup"
                                >
                                  <ul
                                    x-transition:leave="transition ease-in duration-150"
                                    x-transition:leave-start="opacity-100"
                                    x-transition:leave-end="opacity-0"
                                    class="absolute cursor-pointer right-0 top-10 w-56 p-2 mt-2 bg-gray-100 border-gray-400 shadow space-y-2 text-gray-600 bg-white border border-gray-100 rounded-md shadow-md dark:border-gray-700 dark:text-gray-300 dark:bg-gray-700"
                                    aria-label="submenu"
                                    style="z-index: 1"
                                  >
                                    <li
                                      class="flex cursor-pointer"
                                      *ngFor="let signup of signupMemeber"
                                    >
                                      <span
                                        (click)="signupredirect(signup.value)"
                                      >
                                        {{ signup.label }}</span
                                      >
                                    </li>
                                  </ul>
                                </div>
                              </li>
                            </ul>

                            <div class="col-md-12 text-center pri-btn">
                              By using our service, you agree to our
                              <a (click)="privacypolicy()" class="pri-hover"
                                >Privacy Policy</a
                              >.
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="overlay" *ngIf="popupexpired">
    <!-- Popup content -->
    <div class="popup outer-wraper">
      <div class="p-3 mb-4 mt-4 bg-success text-white">
        You have been logged out of this account as you already have started a
        session for another student.
      </div>
      <!-- <p class="mt-4">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea nulla nam
        saepe ratione modi facere, dignissimos vel est quidem nihil odio maiores
        deleniti at quam nostrum eligendi praesentium accusamus quis. Distinctio
        quisquam ipsa culpa quae aspernatur placeat temporibus suscipit
        reprehenderit doloribus iusto possimus consectetur et voluptas alias
        accusantium, minima odio deleniti officiis, aliquid quis, natus aut vel!
        Harum, sed porro.
      </p> -->
      <button (click)="closealert()" class="page-btn mb-3">Close</button>
    </div>
  </div>
</nav>
